import { Metric } from './metric';
import { ScanStatistic } from './scan-statistic';

export interface PentestStatistics {
  metrics: Metric[];
  lastestImpacts: ScanStatistic[];
  lastestWeaknesses: ScanStatistic[];
  lastestCredentials: ScanStatistic[];
}

export namespace PentestStatistics {
  export function mapFromApiValue(pentestStatistics: any) {
    const {
      internalPentestsCount,
      externalPentestsCount,
      uniqHostsCount,
      hostsCountMax,
      lastestImpacts,
      lastestWeaknesses,
      lastestCredentials,
    } = pentestStatistics;
    return {
      metrics: [
        {
          label: 'dashboard.metrics.internalPentests',
          value: internalPentestsCount,
          icon: 'cloud_download',
          iconSize: 1.375,
        },
        {
          label: 'dashboard.metrics.totalUniqueHosts',
          value: uniqHostsCount,
          icon: 'dns',
          iconSize: 1.375,
        },
        {
          label: 'dashboard.metrics.externalScans',
          value: externalPentestsCount,
          icon: 'cloud_upload',
          iconSize: 1.375,
        },
        {
          label: 'dashboard.metrics.hostsInLargestPentest',
          value: hostsCountMax,
          icon: 'bar_chart',
          iconSize: 1.75,
        },
      ],
      lastestImpacts: lastestImpacts.reverse(),
      lastestWeaknesses: lastestWeaknesses.reverse(),
      lastestCredentials: lastestCredentials.reverse(),
    };
  }
}
